export default "__VITE_ASSET__RizA__N7__"